<template>
  <router-view/>
</template>
<script setup>
import { onMounted } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
store.dispatch('auth/initAuth')

onMounted(() => {
  setTheme();
})

function setTheme(){
  let savedTheme = localStorage.getItem('theme');

  if(savedTheme == null){
    localStorage.setItem('theme', 'light');
    document.body.classList.remove('darkmode');
    return;
  }

  if(savedTheme === 'dark'){
     document.body.classList.add('darkmode');
    }else{
     document.body.classList.remove('darkmode');
  }

   
}
</script>

<style>

@font-face {
  font-family: Montserrat-Bold;
  src: url('../src/assets/Fonts/Montserrat-Bold.ttf');
}

@font-face {
  font-family: Montserrat-Regular;
  src: url('../src/assets/Fonts/Montserrat-Regular.ttf');
}

@font-face {
  font-family: Metropolis-Regular;
  src: url('../src/assets/Fonts/Metropolis-Regular.otf');
}

@font-face {
  font-family: Metropolis-Light;
  src: url('../src/assets/Fonts/Metropolis-Light.otf');
}

@font-face {
  font-family: Metropolis-BoldItalic;
  src: url('../src/assets/Fonts/Metropolis-BoldItalic.otf');
}

@font-face {
  font-family: Bebas;
  src: url('../src/assets/Fonts/BebasKai.ttf');
}

@font-face {
  font-family: SourceSans-Bold;
  src: url('../src/assets/Fonts/SourceSansPro-Semibold.ttf');
}

@font-face {
  font-family: SourceSans-Regular;
  src: url('../src/assets/Fonts/SourceSansPro-Regular.ttf');
}

@font-face {
  font-family: JakartaSansSemiBold;
  src: url('../src/assets/Fonts/PlusJakartaSans-SemiBold.ttf');
}

@font-face {
  font-family: JakartaSansBold;
  src: url('../src/assets/Fonts/PlusJakartaSans-Bold.ttf');
}

@font-face {
  font-family: JakartaSansRegular;
  src: url('../src/assets/Fonts/PlusJakartaSans-Regular.ttf');
}
  
:root{
  --nav:white;
  --background:rgb(241, 241, 241);
  --foreground:black;
  --primary:#B121D1;
  --secondary:#E37AFA;
  --tertiary:#611E70;
  --title:1.4rem;
  --subtitle:1.2rem;
  --body:1rem;
  --lightgrey:rgb(218, 214, 214);
  --lightgrey2:rgb(215, 215, 215);
  --lightgrey3:rgb(161, 159, 159);
  --lightgrey4:rgb(161, 159, 159);
  --nav-border:var(--lightgrey2);
  --darkgrey:rgb(84, 84, 84);
  --darkgrey2:rgb(190, 190, 190);
  --darkgrey3:rgb(75, 75, 75);
  --blue:#3f5efb;
   --red:red;
  --gradient:linear-gradient(240deg, var(--blue) 0%, #ea46fc 100%);
  --gradient2:linear-gradient(240deg, var(--blue) 0%, var(--blue) 0%, #ea46fc 100%);
  --del-gradient:rgba(255, 42, 0, 0.231);
  --logo:#611e70;
  --navlink:var(--foreground);
  --navlink-active:var(--primary);
  --sidenav-link:rgb(64, 64, 64);
  --sidenav-link-active:var(--primary);
  --footer:var(--tertiary);
  --footer-text:white;
  --theme-card:grey;
  --theme-card-radius:8px;
  --theme-card-background: white;
  --input-background:white;
  --input-background2:white;
  --input-outline:rgb(162, 161, 161);
  --table-background:rgb(255, 255, 255);
  --pager-button:white;
  --pager-button-text:var(--primary);
  --heading-primary:var(--primary);
  --heading-secondary:rgb(84, 84, 84);
  --border-color:rgb(192, 192, 192);
  --nav-icon:var(--tertiary);
  --page-header:var(--tertiary);
  --list-item:white;
  --scrollbar-color:var(--tertiary);
  --text-grey:rgb(70, 70, 70);
  --heading-font-bold:JakartaSansBold;
  --heading-font-regular:Montserrat-Regular;
  --heading-font2-bold:Metropolis-Bold;
  --heading-font2-regular:Metropolis-Light;
  --heading-font2-italic: Metropolis-BoldItalic;
  --modal-background:white;
  --editor-background:var(--background);
  --editor-foreground:var(--tertiary);
  --editor-border:var(--lightgrey2);
  --filters-accordion-text:rgb(96, 96, 96);
  --filters-accordion-active-color:var(--foreground);
  --filter-selected:var(--primary);
  --builder-accordion-button:rgb(231, 231, 231);
  --placeholder:rgb(147, 147, 147);
  --cv-preview:white;
  --guest-background:white;
  --editor-background2:white;
  --history-color:rgb(79, 75, 75);
  --file-list-border-color:rgb(147, 147, 147);
  --success-message:#b121d152;
  --banner-background:rgba(251, 251, 251, 0.589);
  --slogan:var(--primary);
  --icon-blue:var(--blue);
  --green:rgb(21, 139, 21);
  --orange:rgb(227, 148, 1);
  --enterprise-button:white;
  --toast-success:#611e7082;
  --success-outline:var(--page-header);
  --toast-failed:rgba(127, 20, 20, 0.648);
  --failed-outline:red;
  --toast-text:white;
  --intro:var(--page-header);
  --intro-background:var(--nav);
  --purchase:var(--tertiary);
  --purchase-text:white;
  --expired:linear-gradient(258deg,rgba(217, 26, 26, 0.64) 1%, rgba(252, 185, 172, 0.69) 48%, rgba(253, 209, 255, 0.69) 91%);
  --numbers:Bebas;
  --body-font:JakartaSansRegular;
  --body-font-bold:JakartaSansSemiBold;
  --job-title:var(--page-header);
  --signup-links:var(--primary);
  --home-banner-icon:var(--lightgrey2);
  --history-background:var(--editor-background2);
  --page-header-font:JakartaSansSemiBold;
  --loading-color:var(--primary);
  --job-title-font:JakartaSansBold;
  --job-listings-scroll-bar-color:var(--background);
  --nav-glass:rgba(255, 255, 255, 0.578);
  --info-page-background:var(--nav);
}

.darkmode{
  /* --nav:#1a041e; */
  --nav:#141414;
  /* --background:#201423; */
  /* --background:#241c26; */
  --background:#252226;
  --foreground:rgb(255, 255, 255);
  --logo:white;
  --primary:#B121D1;
  --secondary:#E37AFA;
  --tertiary:#611E70;
  --title:1.4rem;
  --subtitle:1.2rem;
  --body:1rem;
  --lightgrey:rgb(218, 214, 214);
  /* --lightgrey2:rgb(31, 31, 31); */
  --lightgrey2:transparent;
  --lightgrey3:rgb(31, 31, 31);
  --lightgrey4:rgb(237, 237, 237);
  --darkgrey:rgb(84, 84, 84);
  --darkgrey2:rgb(63, 63, 63);
  --darkgrey3:rgb(207, 207, 207);
  --nav-border:rgb(83, 52, 110);
  --blue:rgb(63, 94, 251);
  --red:rgb(249, 70, 70);
  --gradient:linear-gradient(240deg, var(--blue) 0%, #ea46fc 100%);
  --gradient2:linear-gradient(240deg, var(--blue) 0%, var(--blue) 0%, #ea46fc 100%);
  --del-gradient:rgba(249, 70, 70, 0.564);
  --navlink:var(--foreground);
  --navlink-active:var(--secondary);
  --sidenav-link:white;
  --sidenav-link-active:var(--secondary);
  --footer:var(--nav);
  --footer-text:grey;
  --theme-card:grey;
  --theme-card-radius:8px;
  --theme-card-background:linear-gradient(240deg, rgba(225,225,225, 0.08), transparent 60%), var(--footer);
  --input-background:rgb(51, 51, 51);
  --input-background2:var(--nav);
  --input-outline:transparent;
  --table-background:var(--nav);
  --pager-button:var(--background);
  --pager-button-text:var(--secondary);
  --heading-primary:var(--secondary);
  --heading-secondary:var(--foreground);
  --border-color:var(--nav);
  --nav-icon:var(--secondary);
  --page-header:var(--secondary);
 /* --list-item:#19181a;*/
 --list-item:#2d282d;
  --scrollbar-color:var(--secondary);
  --text-grey:rgb(202, 202, 202);
  --modal-background:var(--background);
  --editor-background:var(--input-background);
  --editor-foreground:white;
  --editor-border:var(--input-background);
  --filters-accordion-text:var(--foreground);
  --filters-accordion-active-color:var(--secondary);
  --filter-selected:var(--secondary);
  --builder-accordion-button:var(--editor-background);
  --placeholder:rgb(179, 179, 179);
  --cv-preview:rgb(69, 69, 69);
  --guest-background:var(--background);
  --editor-background2:var(--background);
  --history-color:white;
  --file-list-border-color:transparent;
  --banner-background:#141414;
  --slogan:var(--secondary);
  --icon-blue:#6881ff;
  --green:rgb(118, 232, 118);
  --orange:orange;
  --enterprise-button:black;
  --toast-success:#e27afa87;
  --success-outline:var(--page-header);
  --toast-failed:rgba(239, 93, 93, 0.648);
  --failed-outline:rgb(253, 50, 50);
  --toast-text:white;
  --intro:white;
  --intro-background:#141414ad;
  --purchase:white;
  --purchase-text:var(--nav);
  --job-title:white;
  --signup-links:var(--secondary);
  --home-banner-icon:rgb(40, 40, 40);
  --history-background:var(--darkgrey2);
  --loading-color:var(--secondary);
  --job-listings-scroll-bar-color:var(--background);
  --nav-glass:rgba(20, 20, 20, 0.53);
  --info-page-background:var(--list-item);
}

#app{
  background:var(--background);
  color:var(--foreground);
  font-family: JakartaSansRegular;
  font-size:0.9rem;
}



nav {
  padding: 30px;
}


/* nav a.router-link-exact-active {
  color: var(--primary);
}  */

.default-margin{
  margin:0rem 5rem;
}

.heading-section{
  margin: 1rem 0rem;
  color: var(--primary);
  font-size: var(--title);
}

.heading2-section{
  margin-bottom: 1rem;
  color: var(--sidenav-link-active);
  font-size: var(--subtitle);
}

.default-section{
  margin:1.2rem 1rem;
}

.default-section-accordion{
  margin:1.2rem 1rem;
}


.primary-btn{
  color: white !important;
  background-color: var(--primary)!important;
}

.btn-primary, .btn-secondary{
  border:0px!important;
}

.primary-btn-disabled{
  border:0px!important;
}

.form-buttons{
  display:flex!important;
  column-gap:0.5rem!important;
  margin-top:1rem!important;
}

.section-cv{
  /* border-bottom: 1px solid var(--tertiary); */
}

.cv{
  color: var(--tertiary) !important;
  font-size:0.9rem;
  font-weight: bold;
  border-bottom: 1px solid var(--tertiary);
  padding-bottom:0.6rem;
}

/* HISTORY */

.history{
    /* border:1px solid black; */
    margin-top:1rem;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    row-gap: 0.5rem;
    column-gap: 0.5rem;
}

.hist{
    /* border:1px solid grey; */
    border-radius:12px;
    /* border:1px solid var(--cv-preview); */
    background: var(--history-background);
    color:var(--history-color);
    padding:0.5rem 0.8rem;
    display: grid;
    grid-template-columns:1.4fr auto;
    column-gap:0.1rem;
    
}

.hist-icon{
  height:1.1rem;
}

.hist-icon-edit{
  color:var(--blue);
  height:1.1rem!important;
}

.hist-icon-delete{
  color:var(--red);
}

.button-primary{
    background-color: var(--primary)!important;
    color: white !important;
}

.hist-title{
    font-weight: bold;
    font-size: 0.8rem;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
    max-width:12rem;
}

.hist-company{
    font-size: 0.8rem;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
    max-width:12rem;
}

.hist-date{
    font-size: 0.8rem;
}

.hist-title, .hist-company, .hist-date{
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
}

.hist-controls{
    display: flex;
    column-gap: 0.4rem;
    align-items: center;
    
}

.hist-button{
  height:2rem;
  border-radius:12px;
}



.section-context{
  font-size:0.9rem;
  padding:0.1rem 0rem;
   white-space: pre-wrap; /* Keeps line breaks and wraps text */
    word-wrap: break-word; /* Prevents overflow */
}

 .work{
        margin-bottom: 0.8rem;
    }

  .errors{
        /* border:2px solid red; */
        background:rgba(255, 0, 0, 0.543);
        border-radius:6px;
        margin-bottom:0.5rem;
      }
      
      .error{
        color:white;
        font-size: 0.9rem;
        padding:0.3rem 0.6rem;
        font-family: var(--heading-font2-regular);
    }

    

    /* .error:first-child{
        margin:0rem 0rem;
        margin-bottom:0.8rem;

    }
    
    .error:last-child{
        margin:0rem 0rem;
        margin-top:0.8rem;

    } */

    /* MODAL */
    .modal-content{
      margin-top:5rem;
      border-radius:14px!important;
    }

    .modal-body{
        color:var(--foreground);
        background-color: var(--modal-background);
        border-bottom-left-radius:14px!important;
        border-bottom-right-radius:14px!important;
    }

     .modal-footer{
      border-top:0px!important;
      border-bottom-left-radius: 16px!important;
      border-bottom-right-radius: 16px!important;  
    }

    
    .modal-title{
      height:1rem;
      font-family: var(--body-font);
      color:var(--page-header)
    }

    .modal-title-danger{
      height:1rem;
      font-family: var(--heading-font2-regular);
      color:var(--red)
    }

    .modal-header{
      height:1rem;
      border-bottom:0px!important;
      padding-top:1.5rem;
      padding-bottom:1.5rem;
      padding-right:0.3rem;
      padding-left:0.6rem;
      display: flex;
      justify-content: space-between;
    }

     .close-btn, .close-btn-danger{
      /* transform:translate(14px,2.5px); */
      padding:0.3rem 0rem;
      /* margin-right:-0.9rem; */
    }

    .close-btn:hover{
      /* border:0px; */
    }

    .close-btn:focus,
    .close-btn:active {
        outline: none;
        border: none;
    }

     .close-btn-danger:focus,
    .close-btn-danger:active {
        outline: none;
        border: none;
    }

    

   


   

    .modal-footer, .modal-content{
      background-color: var(--modal-background)!important;
    }

    .close-btn{
      color:var(--page-header)!important;
      /* border:1px solid white; */
    }

    .close-btn-danger{
      color:var(--red)!important;
    }

    .setting{
      border-bottom:1px solid var(--border-color);
      padding:1.5rem 0rem;
    }

    .setting-h1{
      font-size:1.2rem;
      color:var(--heading-primary);
    }

    .setting-h2{
      margin-top:-0.2rem;
      margin-bottom:1.2rem;
      /* font-style: italic; */
      font-size:0.8rem;
      color:var(--heading-secondary);
    }

    .badge-button{
      color:white;
      border:0px;
      background-color: transparent;
    }

    .badge-button-close{
      background-color:white;
      border-radius: 100px;
      border:0px;
    }

    .icon{
      height:1.3rem;
    }

    .badge-container{
      display: flex;
      align-items: center;
    }

    .button-subgroup{
      display:flex;
      column-gap:0.3rem;
    }

    .badge-cancel{
      background-color: var(--lightgrey)!important;
      color:var(--darkgrey)!important;
    }

    .accordion-body{
      padding:0.6rem!important;
    }

/* Default accordion button */
.accordion-button {
  background-color: #f8f9fa!important; /* light gray */
  color: var(--darkgrey);
}


/* Active (pressed/expanded) accordion header */
.accordion-button:not(.collapsed) {
  color: var(--primary) !important;
}

/* Ensure arrow icon and inline svgs inherit the button text color */
.accordion-button svg,
.accordion-button .bi,
.accordion-button::after {
  color: inherit;
  fill: currentColor;
  stroke: currentColor;
}




.widget{
  background: var(--background);
  border-radius: 2px;
  border:1px solid rgb(225, 225, 225);
  box-shadow: 0 8px 24px rgba(16,24,40,0.08);
  padding: 0.5rem;
  min-height:20rem;
}

.widget-loading-indicator{
  margin-top:5rem;
}

.table-header{
  /* border-bottom:1px solid rgb(225, 225, 225); */
  padding-bottom:0.5rem;
  margin-bottom:0.5rem;
}

.theme-card{
  background:var(--nav);
  border-radius: var(--theme-card-radius);
  min-height:15rem;
  margin:1rem;
  padding:0.8rem;
}

.theme-card-header{
  margin-bottom:1rem;
}

.search-query{
    border:1px solid var(--input-outline)!important;
    border-radius:100px!important;
    font-size:0.9rem;
    color:var(--foreground);
    background:var(--input-background)!important;

}

/** TABLES */

#myTable,
#myTable tbody,
#myTable tr,
#myTable th,
#myTable td {
    background-color: var(--theme-card-background) !important;
    color: var(--foreground) !important;
}

#applicantsList,
#applicantsList tbody,
#applicantsList tr,
#applicantsList th,
#applicantsList td {
    background-color: var(--theme-card-background) !important;
    color: var(--foreground) !important;
}


#shortlistedTable,
#shortlistedTable tbody,
#shortlistedTable tr,
#shortlistedTable th,
#shortlistedTable td {
    background-color: var(--theme-card-background) !important;
    color: var(--foreground) !important;
}

input, select{
  border:1px solid var(--input-outline)!important;
  background-color:var(--input-background)!important;
  color:var(--foreground)!important;
}

.form-input{
  border:1px solid var(--input-outline)!important;
  background-color:var(--input-background2)!important;
  color:var(--foreground)!important;
}

 .search-section{
    margin-top:-5.3rem;
    padding-top:2.3rem;
    background: url('./assets/images/vocation-icon-primary.svg') fixed no-repeat, url('../src/assets/images/doodles.png');
        /* background-color:rgba(0,0,0,0.5); */
        /* background-blend-mode: overlay; */
        background-size:cover;
        background-repeat: no-repeat;
        display:flex;
        height:50vh;
        justify-content: center;
        align-items:center;
  }

  .delete-all{
        color:white;
        border:0px;
        border-radius
        :100px;
        margin-top:0.4rem;
        padding: 0.2rem 0.6rem 0.4rem 0.6rem;
        background:var(--red);
    }

    
    




  /**EDITOR */
/* Custom styling */
.custom-quill {
  height: 10rem!important;              /* set editor height */
  border-bottom-left-radius: 8px!important;        /* rounded corners */
  border-bottom-right-radius: 8px!important;        /* rounded corners */
  overflow-y: auto;           /* scroll if content exceeds height */
  border: 1px solid var(--editor-border)!important;
  font-size:0.9rem!important;
  line-height: 1.1rem!important;
  font-family: var(--body-text)!important;
}

/* Optional: style the inner editor area */
.custom-quill .ql-editor {
  min-height: 100%;           /* fill container */
  border-radius: 12px;        /* match outer radius */
}

/* Round the toolbar header */
.ql-toolbar.ql-snow {
  border-radius: 8px 12px 0 0; /* top corners rounded */
 border: 1px solid var(--editor-border)!important;
}

.ql-toolbar{
  background-color: var(--editor-background);
}

/* .ql-editor {
    background-color: var(--input-background);
  
} */

/* Custom vertical scrollbar for WebKit browsers (Chrome, Edge, Safari) */
.ql-editor::-webkit-scrollbar {
  width: 8px;
}

.ql-editor::-webkit-scrollbar-track {
  background: var(--list-item);
  border-radius: 4px;
}

.ql-editor::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-color);
  border-radius: 4px;
  border: 2px solid var(--list-item);
}

.ql-editor::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollbar-color);
}


.ql-toolbar button .ql-stroke {
  stroke: var(--editor-foreground) !important; /* Change to your desired color */
}

.ql-toolbar button .ql-stroke .ql-fill {
  fill: var(--foreground) !important; /* Change to your desired color */
}

.ql-toolbar .ql-size .ql-picker-label {
  stroke: rgb(47, 248, 255) !important; /* Change to your desired color */
}

/* Change color on hover */
.ql-toolbar button:hover .ql-stroke {
  stroke: var(--secondary) !important;
}

/* Optional: Change dropdown arrow color */
.ql-toolbar .ql-picker-label .ql-stroke {
  stroke: var(--editor-foreground) !important;
}

.ql-toolbar .ql-picker-label .ql-stroke:hover {
  stroke: var(--secondary)!important;
}

.ql-picker-label{
  color:var(--editor-foreground);
}

.ql-picker-label:hover{
  color:var(--secondary)!important;
}


.form-label, .to, .form-check-label{
  color:var(--foreground)!important;
}

input::placeholder{
    color:var(--placeholder)!important;
    font-size:0.9rem;
}

textarea::placeholder{
    color:var(--placeholder)!important;
}

 input[type="checkbox"] {
            /* appearance: none;
            -webkit-appearance: none;
            -moz-appearance: none; */
            background-color: var(--list-item)!important;
            /* cursor: pointer; */
            /* position: relative; */
        
        }

        /* Change the background color when checkbox is checked */
        input[type="checkbox"]:checked {
            background-color: var(--primary)!important;
            border: 1px solid var(--primary)!important;
        }

        


 









    

@media(max-width:768px){

   .work{
        margin-bottom: 0.2rem;
    }

  .cv{
 
  font-size:0.7rem;
  font-weight: bold;
  border-bottom: 1px solid var(--tertiary);
  padding-bottom:0.4rem;
}

.section-context{
  font-size:0.7rem;
  padding:0.3rem 0rem;
   white-space: pre-wrap; /* Keeps line breaks and wraps text */
    word-wrap: break-word; /* Prevents overflow */
    line-height: 0.9rem;
}

.heading2-section{
  margin: 0.2rem 0rem;
  
}



.default-section-accordion{
  margin:1rem 0.8rem;
}

 .search-section{
        margin-top:-1.5rem;
        padding-top:2.3rem;
        padding-bottom:2.3rem;
        height: 20rem;
        background-size:fill;
        background-position:-5rem 0rem;
  }

  .default-section{
  margin:1.2rem 0.6rem;
}

.modal-header{

      padding-top:1.5rem;
      padding-bottom:1.5rem;
      padding-right:0.3rem;
      padding-left:0.3rem;
     
    }
}


</style>
